<template>
  <div ref="container" class="grid-container relative mb-40px overflow-hidden">
    <p class="col-span-full mb-16px title-14-h16-m text-primary-100">
      <span
        >{{ title }}
        <span class="ml-8px content-12-h16-r text-primary-60">{{
          $t('message.count_artworks', { count: totalCount })
        }}</span>
      </span>
    </p>
    <DisplayCard v-for="(item, index) in cardContent" :key="index" :content="item" />
    <div
      v-if="hasNextPage && !isLoading"
      class="white-gradient-background absolute bottom-0 h-120px w-full flex cursor-pointer items-end justify-center"
      @click="
        () => {
          expandGridMaxHeight()
          $emit('expend')
        }
      "
    >
      <p
        class="w-240px flex items-center justify-center gap-2px py-8px content-12-h16-r text-primary-80"
      >
        <span>{{ $t('btn.more') }}</span
        ><i class="icon-chevron-down" />
      </p>
    </div>
    <LoadingSpinner class="col-span-full mx-auto" :is-loading="isLoading" />
  </div>
</template>

<script setup lang="ts">
import { nextTick, onMounted, useTemplateRef, watch } from 'vue'

import { type DisplayCardContent } from '@/components/DisplayCards/DisplayCard'
import DisplayCard from '@/components/DisplayCards/DisplayCard.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'

const props = defineProps<{
  cardContent: DisplayCardContent[]
  hasNextPage: boolean
  isLoading: boolean
  title: string
  totalCount: number
}>()

defineEmits<{
  expend: []
}>()

onMounted(() => {
  void setGridMaxHeight()
})
watch(
  () => props.cardContent.length,
  () => {
    void setGridMaxHeight()
  },
)

const container = useTemplateRef<HTMLElement>('container')
async function setGridMaxHeight(): Promise<void> {
  if (container.value === null) return
  container.value.style.maxHeight = 'none'
  if (!props.hasNextPage) return
  await nextTick()
  container.value.style.maxHeight = `${container.value.offsetHeight - 200}px`
}
function expandGridMaxHeight(): void {
  if (container.value !== null) {
    container.value.style.maxHeight = `${container.value.offsetHeight + 340}px`
  }
}
</script>

<style scoped>
.grid-container {
  @apply grid gap-8px justify-center pb-5px;
  grid-template-columns: repeat(auto-fill, 240px);
  transition: max-height 500ms ease;
}
.white-gradient-background {
  background: linear-gradient(
    0deg,
    #fff 35.51%,
    rgba(255, 255, 255, 0.6) 88.42%,
    rgba(255, 255, 255, 0) 133.67%
  );
}
</style>
